const getAllCategoriesLink = (dataList) => {
  const categoriesLink = [
    "fas fa-globe",
    ...new Set(dataList.map((item) => item.categoryLink)),
    ...new Set(dataList.map((item) => item.tagLink)),
  ];
  const uniqueCategoriesLink = Array.from(new Set(categoriesLink));

  return uniqueCategoriesLink;
};

export default getAllCategoriesLink;
